module.exports = __webpack_public_path__ + "img/D201711_2.0874de5a.jpg";